module.exports = __webpack_public_path__ + "img/whyGreen.e95bb365.jpg";